import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const TagInput = ({ label, value, onChange }) => {
  return (
    <Autocomplete
      multiple
      options={["trend", "unisex", "hot", "sale"]} // Thêm danh sách gợi ý
      freeSolo
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      renderInput={(params) => <TextField {...params} label={label} variant="outlined" />}
    />
  );
};

export default TagInput;
